
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/yachts",
      function () {
        return require("private-next-pages/search/yachts.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/yachts"])
      });
    }
  